import { axios } from "@axios";

export type TermsAndConditions = {
  uuid: string;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
};

export type TermsAndConditionsResponse = {
  statusCode: number;
  data: TermsAndConditions | null;
  message: string;
};

export const getTermsAndConditions = (): Promise<TermsAndConditionsResponse> => {
  return axios.get(`/terms-and-conditions`);
};
